import { Modal } from "antd"
import { useApproveRefundRequest } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { EventRefundRequestWithMemberDto } from "@mimber/schema"

export const useApproveRefundRequestModal = (
  eventUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const mutation = useApproveRefundRequest(eventUuid)

  const showApproveRefundRequestModal = (
    refund: EventRefundRequestWithMemberDto
  ): void => {
    modal.confirm({
      title: "Approve Refund Request",
      content: "Are you sure you want to approve this refund request?",
      okText: "Approve",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          mutation.mutate(
            { refundUuid: refund.uuid, data: {} },
            {
              onSuccess: () => {
                message.success("Refund request approved")
                onSuccess?.()
                resolve()
              },
              onError: (error) => {
                message.error(`Failed to approve: ${error.message}`)
                reject()
              },
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showApproveRefundRequestModal,
  }
}
